// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2ahZE","actions":"GroupTable_actions__1KBWx","deleteModalFooter":"GroupTable_deleteModalFooter__j1xZR"};